__turbopack_context__.v({
  "infiniteRotateAnimation": "index-module-scss-module__DC6BVG__infiniteRotateAnimation",
  "logo__img": "index-module-scss-module__DC6BVG__logo__img",
  "logo__label": "index-module-scss-module__DC6BVG__logo__label",
});
